<h5 id="title">{{ "ACTIVITY_LOG" | translate }}</h5>

<h6 class="mt-3"><strong>{{ "DATE_AND_TIME" | translate }}</strong></h6>
<div class="row pb-2">
  <div class="mb-2 mt-3 pl-3 col-12 filters" role="toolbar">
    <mat-form-field class="mr-2 date-field" appearance="outline" floatLabel="always">
      <mat-label>{{ "REPORT_START_DATE" | translate }}</mat-label>
      <input matInput [max]="currentDate" [matDatepicker]="filterStartDatePicker" [(ngModel)]="filterStartDay"
        (dateChange)="updateStartDateTime()" />
        <mat-datepicker-toggle matSuffix [for]="filterStartDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #filterStartDatePicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="mr-2" appearance="outline" floatLabel="always">
        <mat-label>{{ "REPORT_END_DATE" | translate }}</mat-label>
        <input placeholder="{{ 'REPORT_END_DATE' | translate }}" matInput [min]="filterStartDay" [max]="currentDate"
          [(ngModel)]="filterEndDay" [matDatepicker]="filterEndDayPicker"
          (dateChange)="updateEndDateTime()" />
          <mat-datepicker-toggle matSuffix [for]="filterEndDayPicker"></mat-datepicker-toggle>
          <mat-datepicker #filterEndDayPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field class="mr-2" appearance="outline" floatLabel="always">
          <mat-label>{{ "REPORT_START_TIME" | translate }}</mat-label>
          <input pattern="^([0-9]{2}):([0-9]{2})$" (change)="updateStartDateTime()" matInput type="text"
            [(ngModel)]="filterStartTime" />
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>{{ "REPORT_END_TIME" | translate }}</mat-label>
            <input pattern="^([0-9]{2}):([0-9]{2})$" (change)="updateEndDateTime()" matInput type="text"
              [(ngModel)]="filterEndTime" />
            </mat-form-field>
            <div class="col download-log">
              @if (user && user.roleLevel >= 101) {
                <app-download-log
                  [csvHeaders]="['Timestamp', 'Area', 'User', 'Action', 'Details']"
                  [showJson]="true"
                  [startDate]="filterStartDay | date:'yyyy-MM-dd'"
                  [endDate]="filterEndDay | date:'yyyy-MM-dd'"
                  [startTime]="filterStartTime"
                  [endTime]="filterEndTime"
                  [selectedUsers]="activityLogService.filters.users"
                  [selectedAreas]="activityLogService.filters.areas"
                  [selectedActions]="activityLogService.filters.actions"
                  [search]="activityLogService.filters.search">
                </app-download-log>
              }
            </div>
          </div>
        </div>
        <div class="row pb-5">
          <div class="col-10 filters">

            <!-- Hide other than user options until they are implemented
            <app-multiselect-dropdown class="mr-2"
              [label]="'REPORT_TYPE' | translate"
              [placeholder]="'ALL_REPORT_TYPES' | translate"
              [options]="options.reportType">
            </app-multiselect-dropdown> -->

            <app-multiselect-dropdown class="mr-3" data-testid="user-dropdown"
              id="user-select-dropdown"
              [label]="'ACTIVITY_FILTER_USER' | translate"
              [placeholder]="'ALL_USERS' | translate"
              [groupedOptions]="options.users"
              [(selected)]="activityLogService.filters.users"
              (selectedChange)="updateFilters()"
              [enableSearch]="true">
            </app-multiselect-dropdown>

            <app-multiselect-dropdown class="mr-3" data-testid="cameraGroups-dropdown"
              [label]="'CAMERA_GROUPS' | translate"
              [placeholder]="'CAMERA_GROUPS' | translate"
              [options]="options.cameraGroups"
              [(selected)]="activityLogService.filters.cameraGroups"
              (selectedChange)="updateFilters()"
              >
            </app-multiselect-dropdown>

            <app-multiselect-dropdown class="mr-3" data-testid="area-dropdown"
              [label]="'AREA' | translate"
              [placeholder]="'ALL_AREAS' | translate"
              [options]="options.areas"
              [(selected)]="activityLogService.filters.areas"
              (selectedChange)="updateFilters()">
            </app-multiselect-dropdown>

            <app-multiselect-dropdown class="mr-3" data-testid="action-dropdown"
              [label]="'ACTION' | translate"
              [placeholder]="'ALL_ACTIONS' | translate"
              [options]="options.actions"
              [(selected)]="activityLogService.filters.actions"
              (selectedChange)="updateFilters()">
            </app-multiselect-dropdown>

            <button id="clear-filters-btn" (click)="clearFilters()">{{ "CLEAR_FILTER" | translate | capitilize }}</button>
          </div>

          <div class="col input-group search">
            <input type="text" class="form-control search-input"
              [placeholder]="('SEARCH' | translate) + '...'"
              (keyup.enter)="updateFilters()"
              [(ngModel)]="activityLogService.filters.search"
              (input)="onSearchInput($event.target.value)">

              <div class="input-group-append">
                <button class="btn btn-primary" type="button" (click)="updateFilters()">
                  <i class="fa-light fa-magnifying-glass"></i>
                </button>
              </div>
            </div>
          </div>

          <div>
            <app-activity-log-table></app-activity-log-table>
          </div>
